export default __webpack_public_path__ + "Flowers.7886c6fb.png";